<div class="rx-app-flex rx-app-flex-container-column rx-app-flex-container-column--align-stretch">
	<div class="mr-3">
		<span class="doctor-title">{{ 'DoctorSection.Doctor' | translate}}:</span>
	</div>
	<div>
		<span class="doctor-name">{{doctorName}}</span>
	</div>
</div>
